module.exports = __webpack_public_path__ + "img/check-circle.a6eab95a.svg";